export class CustomerDocumentState {
  current_customer_documents = [
    {
      id: '',
      base64: '',
    },
  ];
}
